module.exports = __webpack_public_path__ + "img/recommend_pc.8fe8b86d.png";